<template>
  <a-dropdown style="display: inline-block; height: 100%; vertical-align: initial">
    <span style="cursor: pointer">
      <a-avatar class="avatar" size="small" shape="circle"
                :src="imgUrl ? imgUrl : require('../../static/img/users.svg')"/>
            <span>{{ info.userName }}</span>
    </span>
    <a-menu style="width: 150px;" slot="overlay">
      <!--      <a-menu-item>-->
      <!--        <a-icon type="user" />-->
      <!--        <span>个人中心</span>-->
      <!--      </a-menu-item>-->
      <!--      <a-menu-item>-->
      <!--        <a-icon type="setting" />-->
      <!--        <span>设置</span>-->
      <!--      </a-menu-item>-->
      <!--      <a-menu-divider />-->
      <a-menu-item @click="loginOut">
        <!--        <router-link to="/login">-->
        <a-icon type="poweroff"/>
        <span>退出登录</span>
        <!--        </router-link>-->
      </a-menu-item>
    </a-menu>
  </a-dropdown>
</template>

<script>
export default {
  name: 'HeaderAvatar',
  data() {
    return {
      info: {}
      // imgUrl: 'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1555350606826&di=147020cda162ef41382e1da952b87385&imgtype=0&src=http%3A%2F%2Fkbbos.baidu.com%2Fcomt%2F1456484268_824d1f13f0a88eab01c0d8663e1cf028.png'
    }
  },
  computed: {
    currUser() {
      return this.$store.state.setting.MenuList.userName;
    },
    imgUrl() {
      return this.$store.state.setting.MenuList.avatar;
    },
    roleName() {
      return this.$store.state.setting.MenuList.roleName;
    }
  },
  mounted() {
    this.info = JSON.parse(localStorage.getItem('YUNY_INFO'))
    console.log(typeof this.info);
  },
  methods: {
    loginOut() {
      localStorage.removeItem('YUNY_INFO')
      localStorage.removeItem('LOGIN_ACCESS_TOKEN')
      this.$router.push({path: '/login'})
      // let code = window.location.href.indexOf('code');
      // console.log(code);
      // this.$store.commit('setting/setMenuList', {});
      // if (code > 0) {
      //   window.location.href = window.location.href.split('?')[0];
      // } else {
      //   this.$router.replace('/');
      // }
    }
  }
}
</script>

<style lang="less" scoped>
.avatar {
  margin: 20px 4px 20px 0;
  color: #1890ff;
  background: hsla(0, 0%, 100%, .85);
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/layouts/HeaderlAvatar.vue